import store from '@/store/index.js'
export default {
	data () {
		return {
			imgUrl: '',

		}
	},
	computed: {
		nowRouteName(){
			//console.log('store.state.nowRouteName',store.state.nowRouteName)
			return store.state.nowRouteName
		},
		winH(){
			return store.state.winH
		},
		winW(){
			return store.state.winW
		},
		friendLink(){
			return store.state.friendLink
		}
	},
	
	methods:{
		clog(type,value){
			if(store.state.debug){
				type = type?type:''
				console.log(type,value)
			}
		},
		goUrl(data){
			if(data){
				console.log('data',data)
				//data:url('/index'),object({path:'/index',})
				this.$router.push(data)
			}
		},
		goUrlOut(url){
			if(url){ window.open(url) }
		},
		goBack(){
			this.$router.go(-1);//返回上一层
		},
		
		//获取广告banner图
		getBanner(space_code,limit){
			return new Promise((resolve,reject)=>{
				this.$axios({
					url:'/index.php?s=poster&c=api&m=getPosterList',
					params:{
						space_code:space_code	,//广告位编码 topBanner=顶部大图，indexBanner=中间轮播图，bottomBanner=底部滚动图
						limit:(limit?limit:10),		//限制条数
					},
					success:(res)=>{
						resolve(res.data)
					}
				})
			})
		},
	}
}



// WEBPACK FOOTER //
// ./src/mixins/index.js